import { createSelector } from '@reduxjs/toolkit'

import { toArray } from 'redux/utils'
import { parseFilterQueryParams } from 'components_new/pages/Dashboard/utils'

/* Selectors */
import { selectDashboardPage } from './DashboardPage'

/* Types */
import { ApplicationState } from 'redux/Stores/types'
import { TDashboardWidget, isDashboardWidget } from 'types/GlobalWidget'
import { QueryParams } from 'redux/api/Widgets'
import { parsePeriodFilter } from 'utils/periodFilter'

/**
 * Select all widgets belonging to a specific dashboard
 * @param state - Application state
 * @param dashboardId - Dashboard ID
 * @returns Array of widgets belonging to the dashboard
 * (empty array if no dashboard ID)
 */
export const selectWidgetsInDashboard = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.WidgetStore.widgets,
    (state: ApplicationState, dashboardId: string | null) => dashboardId
  ],
  (widgets, dashboardId): TDashboardWidget[] => {
    if (!dashboardId) return []

    return toArray(widgets)
      .filter(isDashboardWidget)
      .filter((widget) => widget.dashboard_id === dashboardId)
  }
)

export const selectWidgetQueryParams = createSelector(
  [
    selectDashboardPage,
    (_state: ApplicationState, widgetId: string) => widgetId
  ],
  ({ dashboardFilter, periodFilter, customSegmentByMapper }, widgetId) => {
    const segmentBy = customSegmentByMapper[widgetId] || null

    let queryParam: QueryParams | null = parseFilterQueryParams(dashboardFilter)
    const parsedPeriodFilter = parsePeriodFilter(periodFilter)

    if (parsedPeriodFilter) {
      queryParam = {
        ...(queryParam || {}),
        ...parsedPeriodFilter
      }
    }

    if (segmentBy) {
      queryParam = {
        ...(queryParam || {}),
        segment_by: segmentBy
      }
    }

    return queryParam
  }
)
